export const FETCH_ADMINS_REQUEST = "FETCH_ADMINS_REQUEST";
export const FETCH_ADMINS_SUCCESS = "FETCH_ADMINS_SUCCESS";
export const FETCH_ADMINS_FAILURE = "FETCH_ADMINS_FAILURE";

export const CREATE_ADMIN_REQUEST = "CREATE_ADMIN_REQUEST";
export const CREATE_ADMIN_SUCCESS = "CREATE_ADMIN_SUCCESS";
export const CREATE_ADMIN_FAILURE = "CREATE_ADMIN_FAILURE";

export const UPDATE_ADMIN_REQUEST = "UPDATE_ADMIN_REQUEST";
export const UPDATE_ADMIN_SUCCESS = "UPDATE_ADMIN_SUCCESS";
export const UPDATE_ADMIN_FAILURE = "UPDATE_ADMIN_FAILURE";

export const SET_ADMIN_STATUS_SUCCESS = "SET_ADMIN_STATUS_SUCCESS";
export const SET_ADMIN_STATUS_FAILURE = "SET_ADMIN_STATUS_FAILURE";

export const DELETE_ADMIN_SUCCESS = "DELETE_ADMIN_SUCCESS";
export const DELETE_ADMIN_FAILURE = "DELETE_ADMIN_FAILURE";

export const RESET_ADMIN_PASSWORD_SUCCESS = "RESET_ADMIN_PASSWORD_SUCCESS";
export const RESET_ADMIN_PASSWORD_FAILURE = "RESET_ADMIN_PASSWORD_FAILURE";

export const FETCH_METRICS_SUCCESS = "FETCH_METRICS_SUCCESS";
export const FETCH_METRICS_FAILURE = "FETCH_METRICS_FAILURE";

export const FETCH_ANALYTICS_SUCCESS = "FETCH_ANALYTICS_SUCCESS";
export const FETCH_ANALYTICS_FAILURE = "FETCH_ANALYTICS_FAILURE";

export const FETCH_ADMIN_ACTIVITY_SUCCESS = "FETCH_ADMIN_ACTIVITY_SUCCESS";
export const FETCH_ADMIN_ACTIVITY_FAILURE = "FETCH_ADMIN_ACTIVITY_FAILURE";

export const FETCH_UNOWNED_SUCCESS = "FETCH_UNOWNED_SUCCESS";
export const FETCH_UNOWNED_FAILURE = "FETCH_UNOWNED_FAILURE";

export const REASSIGN_UNOWNED_SUCCESS = "REASSIGN_UNOWNED_SUCCESS";
export const REASSIGN_UNOWNED_FAILURE = "REASSIGN_UNOWNED_FAILURE";
